import { observer } from "mobx-react-lite"
import { useContext, useEffect, useState } from "react";
import BankAPI from "../API/BankAPI";
import Dropbox from "../components/ui/Dropbox";
import ParamField from "../components/ui/ParamField";
import SingleTable from "../components/tables/SingleTable";
import SingleRow from "../components/tables/SingleRow";
import MultiSwitcherStage from "../components/ui/MultiSwitcherStage";
import SwitcherParams from "../components/ui/SwitcherParams";
import useAssociationsEditor from "../hooks/useAssociationsEditor";
import useBank from "../hooks/useBank";
import { Context } from "..";
const bank_settings = require("../settings/bank.json");

const Bank = () => {   
    const { store } = useContext(Context);
    const [params, setParams] = useState({});
    const [isLoading, setLoading] = useState(true);
    const [isMe, setIsMe] = useState(true);
    const [isMePage, setIsMePage] = useState(true);
    const [isOpenedDropbox, setIsOpenedDropbox] = useState(null);
    const [dropboxes, setDropboxes] = useState({
        bankMegaPriceOfStatements: {
            values: bank_settings.bank_statements,
            defaultValue: 0,
            currentValue: 0,
            isOpened: false
        },
        bankMegaPriceOfTimeLimit: {
            values: bank_settings.time_limit,
            defaultValue: 0,
            currentValue: 0,
            isOpened: false
        },
    })
    const changeOpenedDropbox = (dropboxName, state) => {
        let newDropboxes = { ...dropboxes };
        if (isOpenedDropbox != null) newDropboxes[isOpenedDropbox].isOpened = false;
        setDropboxes({ ...newDropboxes, [dropboxName]: { ...newDropboxes[dropboxName], isOpened: state } });

        if (state) setIsOpenedDropbox(dropboxName);
        else setIsOpenedDropbox(null);
    }
    const changeValueDropbox = (dropboxName, value) => {
        let newDropboxes = { ...dropboxes, [isOpenedDropbox]: { ...dropboxes[isOpenedDropbox], isOpened: false } };
        setDropboxes({ ...newDropboxes, [dropboxName]: { ...newDropboxes[dropboxName], currentValue: value } });
    
        if (dropboxName != "association") return;
        changeAssociation(value != 0 ? newDropboxes.association.values[value].id : null);
    }

    const { bank_summ, bank_hourCost, bank_changeAssociation } = useBank(isMe, dropboxes.bankMegaPriceOfStatements.values[dropboxes.bankMegaPriceOfStatements.currentValue].value, dropboxes.bankMegaPriceOfTimeLimit.values[dropboxes.bankMegaPriceOfTimeLimit.currentValue].value);

    const { associationsDropbox, changeAssociation } = useAssociationsEditor("bank_id");
    useEffect(() => {
        if (!associationsDropbox || associationsDropbox === null || !associationsDropbox.values || associationsDropbox.values.length === 0) return;
        bank_changeAssociation();
        setDropboxes({ ...dropboxes, association: associationsDropbox });
    }, [associationsDropbox]);
    useEffect(() => {
        loadData().then(() => console.log("Операции банка загружены"));
    }, []);

    const loadData = async () => {
        try {
            const paramsData = await BankAPI.getAll();
            if (paramsData.status !== 200) throw paramsData;

            setParams(paramsData.data);
            setLoading(false);
        } catch (err) {
            console.log("[x] Ошибка загрузки параметров банка:", err);
        }
    }
    const saveValue = async () => {
        try {
            const response = await BankAPI.update(params);
            if (response.status !== 200) throw response;
        } catch (err) {
            console.log("[x] Ошибка сохранения параметров банка:", err);
        }
    }
    const formatNumber = (num) => {
        if (!num) return 0;
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }

    return (
        <div className="setupBlock">
            <div className="managementMenu">
                <button className="activeButton" onClick={() => window.location.replace("/calc")}>Назад</button>
            </div>
            <div className="setupContent" style={{ overflowY: "auto" }}>
                <div className="paramsBlock">
                    <div className="title">Банк</div>
                    { dropboxes.association && <div className={`paramsList${dropboxes.association.currentValue === 0 ? " error" : ""}`} style={{ flex: 0 }}>
                        <ul>
                            <li>
                                <div className="params" style={{ width: 430 }}>
                                    <div className="title">Ответственный</div>
                                    <div className="attribute">
                                        <Dropbox 
                                            textValue={dropboxes.association.values[dropboxes.association.currentValue]?.name}
                                            isRight={true}
                                            isOpen={dropboxes.association.isOpened}
                                            changeOpened={(value) => changeOpenedDropbox("association", value)}
                                            isError={dropboxes.association.currentValue === 0}
                                        >
                                            {dropboxes.association.values.map((item, index) => <li 
                                                className={dropboxes.association.currentValue === index || (dropboxes.association.currentValue === null && index == 0) ? "selected" : ""}
                                                key={item+index}
                                                onClick={() => changeValueDropbox("association", index)}
                                            >
                                                <div className="number">{index+1}.</div>
                                                <div className="value">{item.name}</div>
                                            </li>)}
                                        </Dropbox>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div> }
                    <div className="paramsList">
                        <ul>
                            <li>
                                <div className="params" style={{ width: 430 }}>
                                    <div className="title">Кто вносит первичку</div>
                                    <div className="attribute"><SwitcherParams name1="Мы" name2="Клиент" onChangeValue={(value) => setIsMe(!value)}/></div>
                                </div>
                            </li>
                            <li>
                                <div className="params">
                                    <div className="title">Диапазон кол-ва документов</div>
                                    <div className="attribute"><Dropbox
                                        textValue={dropboxes.bankMegaPriceOfStatements.values[dropboxes.bankMegaPriceOfStatements.currentValue]?.name}
                                        isRight={true}
                                        isOpen={dropboxes.bankMegaPriceOfStatements.isOpened}
                                        changeOpened={(value) => changeOpenedDropbox("bankMegaPriceOfStatements", value)}
                                    >
                                        {dropboxes.bankMegaPriceOfStatements.values.map((item, index) => <li 
                                            className={dropboxes.bankMegaPriceOfStatements.currentValue === index ? "selected" : ""}
                                            key={item+index}
                                            onClick={() => changeValueDropbox("bankMegaPriceOfStatements", index)}
                                        >
                                            <div className="number">{index+1}.</div>
                                            <div className="value">{item.name}</div>
                                        </li>)}
                                    </Dropbox></div>
                                </div>
                            </li>
                            <li>
                                <div className="params">
                                    <div className="title">Количество загрузок выписки в месяц</div>
                                    <div className="attribute"><Dropbox
                                        textValue={dropboxes.bankMegaPriceOfTimeLimit.values[dropboxes.bankMegaPriceOfTimeLimit.currentValue]?.name}
                                        isRight={true}
                                        isOpen={dropboxes.bankMegaPriceOfTimeLimit.isOpened}
                                        changeOpened={(value) => changeOpenedDropbox("bankMegaPriceOfTimeLimit", value)}
                                    >
                                        {dropboxes.bankMegaPriceOfTimeLimit.values.map((item, index) => <li 
                                            className={dropboxes.bankMegaPriceOfTimeLimit.currentValue === index ? "selected" : ""}
                                            key={item+index}
                                            onClick={() => changeValueDropbox("bankMegaPriceOfTimeLimit", index)}
                                        >
                                            <div className="number">{index+1}.</div>
                                            <div className="value">{item.name}</div>
                                        </li>)}
                                    </Dropbox></div>
                                </div>
                            </li>
                        </ul>
                        <div className="summ">
                            <div className="text">Итого:</div>
                            <div className="value">{ isLoading == false && formatNumber(bank_summ)} ₽</div>
                        </div>
                    </div>
                </div>
                <div className="contentSetupBlock">
                    {isLoading == false && <div>
                        <div className="title">Время на загрузку</div>
                        <div className="block_twoFields">
                            <div>
                                <div className="title">Вносим мы</div>
                                <div className="list">
                                    <ParamField 
                                        title="На 1 документ" 
                                        value={params.me.time_doc}
                                        setValue={(newValue) => {
                                            setParams({ ...params, me: { ...params.me, time_doc: newValue }});
                                            saveValue({ ...params, me: { ...params.me, time_doc: newValue }});
                                        }}
                                        disabled={!store.userInfo || store.userInfo.isLicensed == false}
                                    />
                                    <ParamField 
                                        title="На 1 строку"
                                        value={params.me.time_line}
                                        setValue={(newValue) => {
                                            setParams({ ...params, me: { ...params.me, time_line: newValue }});
                                            saveValue({ ...params, me: { ...params.me, time_line: newValue }});
                                        }}
                                        disabled={!store.userInfo || store.userInfo.isLicensed == false}
                                    />
                                </div>
                            </div>
                            <div>
                                <div className="title">Вносит клиент</div>
                                <div className="list">
                                    <ParamField 
                                        title="На 1 документ" 
                                        value={params.client.time_doc}
                                        setValue={(newValue) => {
                                            setParams({ ...params, client: { ...params.client, time_doc: newValue }});
                                            saveValue({ ...params, client: { ...params.client, time_doc: newValue }});
                                        }}
                                        disabled={!store.userInfo || store.userInfo.isLicensed == false}
                                    />
                                    <ParamField 
                                        title="На 1 строку"
                                        value={params.client.time_line}
                                        setValue={(newValue) => {
                                            setParams({ ...params, client: { ...params.client, time_line: newValue }});
                                            saveValue({ ...params, client: { ...params.client, time_line: newValue }});
                                        }}
                                        disabled={!store.userInfo || store.userInfo.isLicensed == false}
                                    />
                                </div>
                            </div>
                        </div>
                    </div> }
                    <div>
                        <div className="title">
                            <div className="text">Диапазон количества строк банковской выписки</div>
                            <MultiSwitcherStage
                                values={[ { name: "Вносим Мы" }, { name:"Вносит Клиент" } ]}
                                selectValue={(value) => setIsMePage(value == 0 ? true : false)}
                                defaultValue={isMePage ? 0 : 1}
                                backIsWhite={true}
                            />
                        </div>
                        <div className="block_table">
                            { isLoading == false && isMePage && <SingleTable topHeader="Количество раз загрузки выписки в месяц" header={{ title: "Кол-во строк выписки", list: bank_settings.time_limit }}>
                                {bank_settings.bank_statements.map((item, index) => 
                                    <SingleRow values={{ title: item.name, list: bank_settings.time_limit.map((itemTime, indextime) => (
                                        formatNumber(Math.ceil((item.value * params.me.time_line + itemTime.value * params.me.time_doc) * (bank_hourCost / 60))) + " ₽"
                                    ))}} key={item+index}/>
                                )}
                            </SingleTable> }
                            { isLoading == false && !isMePage && <SingleTable header={{ title: "Кол-во строк выписки", list: [{ name: "Время" }, { name: "Стоимость" }] }}>
                                {bank_settings.bank_statements.map((item, index) => 
                                    <SingleRow values={{ title: item.name, list: [
                                        item.value * params.client.time_doc,
                                        formatNumber(Math.ceil(item.value * params.client.time_doc * (bank_hourCost / 60))) + " ₽"
                                    ] }} key={item+index}/>
                                )}
                            </SingleTable> }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default observer(Bank);
